module.exports = __webpack_public_path__ + "fonts/montserrat-latin-900-normal.13e7bd8.woff2";